import React from 'react'
import { Link } from "react-router-dom";
import HomeReviews from '../home/HomeReviews';


const Clientele = () => {
    return (
        <>

            <section className="page-hero bg_cover p-r z-1" style={{ backgroundImage: 'url("assets/img/TDR.jpg")' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            {/*=== Page Content ===*/}
                            <div className="page-content text-center">
                                <h1>Clientele</h1>
                                <ul>
                                    <li><Link to="/">Home</Link></li>
                                    <li>Clientele</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div style={{marginTop:"100px"}}>
                <HomeReviews />
            </div>




        </>
    )
}

export default Clientele